require('./bootstrap');

export const initTypeAHeadListeners = function () {

    var Bloodhound = require('bloodhound-js');

    var typeaheadSettings = {
        minLength: 1,
        highlight: true,
        hint: false,
    };

    var sourceSettings = {
        display: 'name',
        limit: 20,
    };

    var dynamicSourceSettings = {
        display: 'name',
        limit: 100,
    };

    var orphanSource = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('client'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/dynamic/typeahead/client/%QUERY',
            wildcard: '%QUERY',
        }
    });

    var source = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/dynamic/typeahead/client/%QUERY',
            wildcard: '%QUERY',
        }
    });

    orphanSource.initialize();

    var $orphanSearch = $('#orphanClientSearch').typeahead(typeaheadSettings, $.extend({ name: 'mySource_topsearch', source: source }, sourceSettings))
        .on("typeahead:selected typeahead:autocompleted", function (e, item) {
            window.location = window.location.href + "&cid=" + item.id
        })
        .unbind("blur")
        .on("blur", function () {
            $orphanSearch.typeahead("close");
        })
        .on('typeahead:asyncrequest', function (e) {
            $orphanSearch.addClass('loading');
        })
        .on('typeahead:asynccancel typeahead:asyncreceive', function (e) {
            $orphanSearch.removeClass('loading');
        });

    var $topSearch = $('#top_search_form input:text').typeahead(typeaheadSettings, $.extend({ name: 'mySource_topsearch', source: source }, sourceSettings))
        .on("typeahead:selected typeahead:autocompleted", function (e, item) {
            window.location = '/clients/' + item.id;
        })
        .unbind("blur")
        .on("blur", function () {
            $topSearch.typeahead("close");
        })
        .on('typeahead:asyncrequest', function (e) {
            $topSearch.addClass('loading');
        })
        .on('typeahead:asynccancel typeahead:asyncreceive', function (e) {
            $topSearch.removeClass('loading');
        });

    $('[enable-typeahead]').each(function (index) {

        var model = $(this).data('typeahead-model');

        if (model) {

            var source = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: '../dynamic/typeahead/' + model + '/%QUERY',
                    wildcard: '%QUERY',
                }
            });

            var $el = $(this);

            var $hidden = $('<input type="hidden" name="' + $el.attr('name') + '" value="" />');
            $el.removeAttr('name');
            $hidden.insertAfter($el);
            var $viewId = $('<span></span>').insertAfter($el);
            var val = $el.val();
            var ph = 'Search for a ' + model.charAt(0).toUpperCase() + model.slice(1);
            $el.attr('placeholder', ph);

            if (val) {
                $hidden.val(val);
                $el.val('');
                $viewId.html(' ID: ' + val);
                $el.attr('placeholder', 'Loading Value...');
                $.get('/dynamic/name/' + model + '/' + val, function (data) {
                    console.log(data);
                    $el.val(data);
                    $el.attr('placeholder', ph);
                });
            }

            if ($el.attr('readonly')) {
                $el.wrap($('<span/>', {
                    class: 'readonly-text-wrap'
                }));
            } else {

                $el.typeahead(typeaheadSettings, $.extend({
                    name: 'mySource_' + index,
                    source: source
                }, dynamicSourceSettings))
                    .on("typeahead:selected typeahead:autocompleted", function (e, item) {
                        //Sets or Re-Sets "required on expires for guide_certifications"
                        if (model == 'certification' && item.expires == 1) {
                            $('input[name^="models[guide_certification][expires]"]').prop('required', true);
                        }
                        //Sets or Re-Sets "required on expires for guide_certifications"
                        if (model == 'certification' && item.expires == 0) {
                            $('input[name^="models[guide_certification][expires]"]').prop('required', false);
                        }
                        $hidden.val(item.id);
                        $viewId.html(' ID: ' + item.id);
                    })
                    .unbind("blur")
                    .on("blur", function () {
                        $el.typeahead("close");
                    })
                    .on('typeahead:asyncrequest', function (e) {
                        $el.addClass('loading');
                    })
                    .on('typeahead:asynccancel typeahead:asyncreceive', function (e) {
                        $el.removeClass('loading');
                    });
            }
        }
    });
}